import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./componentes/Layout.tsx";
import MisMascotas from "./paginas/MisMascotas.tsx";
import MascotaDetalle from "./paginas/MascotaDetalle.tsx";
import MascotaForm from "./paginas/MascotaForm.tsx";
import VisitaForm from "./paginas/VisitaForm.tsx";
import ModuloDatos from "./paginas/ModuloDatos.tsx";
import ModuloAdmin from "./paginas/ModuloAdmin.tsx";
import CanjeInvitacion from "./paginas/CanjeInvitacion.tsx";
import MiPerfil from "./paginas/MiPerfil.tsx";
import RecetaDetalle from "./paginas/RecetaDetalle.tsx";
import CarnetVacunacion from "./paginas/CarnetVacunacion.tsx";
import NoEncontrado from "./paginas/NoEncontrado.tsx";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Un 401 o un 404 no se arreglan reintentando.
      retry: (intentos, error) => {
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403 || status === 404) return false;
        return intentos < 2;
      },
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Falta el elemento #root en index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/invitacion/:token" element={<CanjeInvitacion />} />
          <Route path="/carnet/:token" element={<CarnetVacunacion />} />
          <Route element={<Layout />}>
            <Route path="/" element={<MisMascotas />} />
            <Route path="/perfil" element={<MiPerfil />} />
            <Route path="/mascotas/nueva" element={<MascotaForm />} />
            <Route path="/mascotas/:mascotaID" element={<MascotaDetalle />} />
            <Route path="/mascotas/:mascotaID/editar" element={<MascotaForm />} />
            <Route path="/mascotas/:mascotaID/carnet" element={<CarnetVacunacion />} />
            <Route path="/mascotas/:mascotaID/visitas/nueva" element={<VisitaForm />} />
            <Route path="/visitas/:visitaID/editar" element={<VisitaForm />} />
            <Route path="/recetas/:recetaID" element={<RecetaDetalle />} />
            <Route path="/datos" element={<ModuloDatos />} />
            <Route path="/admin" element={<ModuloAdmin />} />
            <Route path="*" element={<NoEncontrado />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
